import { useEffect, useState } from "react";
import {
  connectWallet,
  getCurrentWalletConnected,
  mintNFT,
  mintthreeNFT,
  claimBeam,
  claimBeamloop,//import here} from "./utils/interact.js";
  claimBeamLoop,
  checkDopplers
} from "./utils/interact.js";


const Minter = (props) => {

  function addWalletListener() {
  if (window.ethereum) {
    window.ethereum.on("accountsChanged", (accounts) => {
      if (accounts.length > 0) {
        setWallet(accounts[0]);
        setStatus("👆🏽 Write a message in the text-field above.");
      } else {
        setWallet("");
        setStatus("🦊 Connect to Metamask using the top button.");
      }
    });
  } else {
    setStatus(
      <p>
        {" "}
        🦊{" "}
        <a target="_blank" href={`https://metamask.io/download.html`}>
          You must install Metamask, a virtual Ethereum wallet, in your
          browser.
        </a>
      </p>
    );
    }
  }

  //State variables
  const [walletAddress, setWallet] = useState("");
  const [status, setStatus] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [url, setURL] = useState("");
  const [wizstatus, setWizStatus] = useState(""); 
  useEffect(async () => { //TODO: implement
    const {address, status} = await getCurrentWalletConnected();
    setWallet(address)
    setStatus(status);
    
        
    addWalletListener(); 
  }, []);

  const connectWalletPressed = async () => { //TODO: implement
    const walletResponse = await connectWallet();
    setStatus(walletResponse.status);
    setWallet(walletResponse.address);
  };

  const onMintPressed = async () => { //TODO: implement
      const { status } = await mintNFT();
    setStatus(status);  
  };

  const onMintthreePressed = async () => { //TODO: implement
      const { status } = await mintthreeNFT();
    setStatus(status);  
  };

  const onClaimPressed = async () => { //TODO: implement
      const { status } = await claimBeam();
  };

  const onClaimLoopPressed = async () => { //TODO: implement
      const { status } = await claimBeamLoop();
  };

  const onCheckPressed = async () => { //TODO: implement
      const { wizstatus } = await checkDopplers(name);
    setWizStatus(wizstatus);  
  };

  return (
    <div className="Minter">
      <button id="walletButton" onClick={connectWalletPressed}>
        {walletAddress.length > 0 ? (
          "Connected: " +
          String(walletAddress).substring(0, 6) +
          "..." +
          String(walletAddress).substring(38)
        ) : (
          <span>Connect Wallet</span>
        )}
      </button>

      <br></br>
      <h1 id="title">Dirty Punkinz</h1>
      <h1 id="title">DROP: Oct 25th 3pm EST</h1>
      <h4> Mint your Dirty Punkinz NFT! You can mint 1 for 0.01 ETH, or buy 2 get one free (3 NFTs) for 0.02 ETH! Please read the terms and conditions at the bottom of the page that you agree to by using this site. Disclaimer: Use this website at your own risk! </h4>

      <p>
       
      </p>
      <br>
      </br>      <br>
      </br>
    <h2> Deal: Buy 2 get one free (Total = 0.02 ETH for 3 NFTs)</h2>
      <button id="mintButton" onClick={onMintthreePressed}>
        Mint Deal (3)!
      </button>
      <p id="status">
      </p>

      <br>
      </br>
      <br>
      </br>      

    <h2> Mint a Dirty Punkin for 0.01 ETH</h2>
      <button id="mintButton" onClick={onMintPressed}>
        Mint One!
      </button>
      <p id="status">
      </p>

      <br>
      </br>


        <p id="wizstatus">
        {wizstatus}
              </p>

      <br>
      </br>        

    <h5>Terms and Conditions: Your purchase of Dirty Punkinz NFTs does NOT CONSTITUTE AN INVESTMENT. Purchase of these NFTs from Dirty Punkinz is meant for entertainment purposes only. Dirty Punkinz makes no warranties regarding future value, express or implied, to the public or to buyers. Only purchase if you wish to own the artwork and nothing else. Only purchase with the current state of the project in mind and the assumption that no future value will be delivered. Dirty Punkinz NFTs are not currency and do not convey ownership in Dirty Punkinz or its assets. You are purchasing a digital collectible, we do not guarantee any future development around these NFTs. Dirty Punkinz tokens are not shares or securities of any type. Holding a token does not entitle the holder to any ownership or other interest in Dirty Punkinz, future business operations, future revenue, or any control or ability to bind the entity. There is no guarantee that there will be further development or support, although we guarantee that it is our intention to do so.
</h5>

      <br>
      </br>        
      <br>
      </br>        

    </div>
  );
};



export default Minter;
